import { FC } from 'react';
import { Button, Label } from '../../atoms';
import BaseTemplate from '../BaseTemplate';

import styles from './ReportingDetailsVerificationStatusesTemplate.module.css';
import { VerificationStatusResponseDto } from '../../../store/landscapeAPI/verificationStatus/dto/response/verification-status-response.dto';
import { useNavigate } from 'react-router-dom';
import { ReportingDetailsVerificationStatuses } from '../../organisms';

export interface ReportingDetailsVerificationStatusesTemplateProps {
  data: VerificationStatusResponseDto[];
  handleDeleteVerificationStatus: (id: string) => void;
}

const ReportingDetailsVerificationStatusesTemplate: FC<
  ReportingDetailsVerificationStatusesTemplateProps
> = ({ data, handleDeleteVerificationStatus }) => {
  const navigate = useNavigate();

  return (
    <BaseTemplate>
      <div className={styles.heading}>
        <Label content="Progress Reporting - Verification Statuses" size="lg" />
        <Button
          onClick={() =>
            navigate('/reporting-details/verification-statuses/add')
          }
          variant="dark"
        >
          Add Status
        </Button>
      </div>
      <ReportingDetailsVerificationStatuses
        data={data}
        handleDeleteVerificationStatus={handleDeleteVerificationStatus}
      />
    </BaseTemplate>
  );
};

export default ReportingDetailsVerificationStatusesTemplate;
